
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.883.797h1.265V5.32c0 1.521-.377 2.7-1.132 3.54-.756.838-1.779 1.257-3.07 1.257-1.292 0-2.316-.427-3.071-1.281C1.125 7.976.75 6.696.75 4.992V.797h1.266v4.226c0 1.365.265 2.375.796 3.032.537.65 1.248.976 2.133.976.886 0 1.597-.325 2.133-.976.537-.657.805-1.667.805-3.032V.797z","fill":"currentColor"}})])
          )
        }
      }
    